import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/* istanbul ignore next */
export function futureDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selectedDate = control.value;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selectedDate && selectedDate <= today ? { notFutureDate: true } : null;
  };
}

/* istanbul ignore next */
export function todayOrFutureDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selectedDate = control.value;
    if (!selectedDate) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return new Date(selectedDate) < today ? { pastDate: true } : null;
  };
}

/* istanbul ignore next */
export function customPriceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const parent = control.parent;
    if (!parent) return null;
    const useCustomPrice = parent.get('useCustomPrice')?.value;
    const customPrice = control.value;
    if (useCustomPrice) {
      if (customPrice === null || customPrice === undefined || customPrice === '') {
        return { requiredCustomPrice: true };
      }
    }
    return null;
  };
}

/* istanbul ignore next */
export function cleanPhoneNumberValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = control.value;
    if (!rawValue) return null;
    const cleanedValue = rawValue.replace(/[\s\-+]/g, '');
    if (cleanedValue.length < minLength) {
      return { invalidPhoneNumber: true };
    }
    return null;
  };
}

/* istanbul ignore next */
export function integerValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;
    return !Number.isInteger(Number(value)) ? { notInteger: true } : null;
  };
}

/* istanbul ignore next */
export function strictEmailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const value = control.value;
  if (value && !emailRegex.test(value)) {
    return { invalidEmail: true };
  }
  return null;
}
